export const mobileMenuCls = 'mobile-menu-open';
export const homeCls = 'home';
export const homeContentCls = 'home-content';

export const MOBILE_VIEW_PX = 992;
